<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.my_account') }}</span>
    </div>
    <div class="pt-30 page-card-content" v-loading="loading">
      <div class="mb-30">
        <div class="section-title mb-15">
          {{ $t('text.account_information') }}
        </div>
        <el-descriptions :column="3" border>
          <el-descriptions-item :label="$t('text.given_name')">{{
            userDetail && userDetail.GivenName ? userDetail.GivenName : '--'
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('text.surname')">{{
            userDetail && userDetail.Surname ? userDetail.Surname : '--'
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('text.display_name')">{{
            userDetail && userDetail.DisplayName ? userDetail.DisplayName : '--'
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('text.email')" :span="3">{{
            userDetail && userDetail.Email ? userDetail.Email : '--'
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div>
        <div class="section-title mb-15">{{ $t('text.data_management') }}</div>
        <div class="mb-5">
          {{ $t('text.data_management_desc') }}
        </div>
        <div class="mb-20">
          <a
            class="underline general-font"
            target="_blank"
            href="https://www.smartzhealth.com/downloads/"
            >{{ $t('text.how_can_i_export') }}</a
          >
        </div>
        <el-button
          type="success"
          plain
          class="common-btn"
          :loading="deleteLoading"
          :disabled="deleteLoading"
          @click="deleteUser()"
          >{{ $t('text.delete_account_data') }}</el-button
        >
      </div>
      <el-divider></el-divider>
      <div>
        <div class="section-title mb-15">
          {{ $t('text.group_data_rentenion') }}
        </div>
        <div class="mb-5">
          {{ $t('text.maximum_inactivity_data_retention_period') }}
          <el-input-number
            v-model="maximum_period"
            controls-position="right"
            class="ml-20 mr-10"
            size="mini"
          ></el-input-number
          >{{ $t('text.months') }}
        </div>
        <div>
          <div>
            {{
              $t('text.group_data_rentenion_desc', {
                patients: $firstLetterCapitalize($store.state.locale.patients)
              })
            }}
          </div>
          <div
            v-html="
              $t('text.data_rentenion_detail', {
                patient: $firstLetterCapitalize($store.state.locale.patient)
              })
            "
          ></div>
          <el-button
            type="success"
            @click="changeGroupRetention()"
            :loading="changeGroupRetentionLoading"
            plain
            class="common-btn mt-20"
            >{{ $t('text.save_preference') }}</el-button
          >
        </div>
      </div>
      <el-divider></el-divider>
      <ComplianceNotifications
        :showUserEmailSubscriptionStatusByDefault="true"
      />
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import ComplianceNotifications from '@/components/register/ComplianceNotifications.vue'
export default {
  data() {
    return {
      loading: false,
      deleteLoading: false,
      saveLoading: false,
      changeGroupRetentionLoading: false,
      maximum_period: '',
      user: JSON.parse(localStorage.getItem('user')),
      userDetail: {}
    }
  },
  components: {
    ComplianceNotifications
  },
  mounted() {
    if (this.user) {
      this.maximum_period = this.user.retentionPeriod
    }
    this.getUserDetail()
  },
  methods: {
    deleteUser() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_account_warning'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.account_deletion'),
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeleteUser()
        })
        .catch(() => {})
    },
    handleDeleteUser() {
      this.deleteLoading = true
      ApiService.DeleteUser()
        .then(response => {
          this.deleteLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.deleted_successfully')
            })
            this.$loading({
              lock: true,
              text: this.$t('text.sign_out') + '...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            this.$store.dispatch('user/logout')
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.deleted_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.deleteLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.deleted_failed')
          })
        })
    },
    changeGroupRetention() {
      this.changeGroupRetentionLoading = true
      ApiService.ChangeGroupRetention(this.maximum_period)
        .then(response => {
          this.changeGroupRetentionLoading = false
          if (response.data.success) {
            this.updateUserLocalstorage()
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.changeGroupRetentionLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    },
    updateUserLocalstorage() {
      this.user.retentionPeriod = this.maximum_period
      localStorage.setItem('user', JSON.stringify(this.user))
      this.$store.commit('user/SET_USER_DATA', this.user)
    },
    getUserDetail() {
      this.loading = true
      ApiService.GetAzureUserDetail()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.userDetail = response.data.data
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    }
  }
}
</script>
